// ABOUTME: Rebuilds a route pattern (e.g. /offers/:offerId) from a pathname and its matched params.
// ABOUTME: react-router 6 data matches expose params but not the route path.

import type { Params } from 'react-router-dom';

function safeDecode(segment: string) {
    try {
        return decodeURIComponent(segment);
    } catch {
        return segment;
    }
}

// react-router 6 matches expose params but not the route path: the pattern is rebuilt by putting
// each param name back where its value sits. A splat collapses to "*".
export function buildRoutePattern(pathname: string, params: Params): string {
    const splat = params['*'];
    const base = splat ? pathname.slice(0, pathname.length - splat.length) : pathname;
    const nameByValue = new Map(
        Object.entries(params)
            .filter(([key, value]) => key !== '*' && !!value)
            .map(([key, value]) => [value as string, key]),
    );
    const pattern = base
        .split('/')
        .map(segment => {
            const name = segment ? nameByValue.get(safeDecode(segment)) : undefined;
            return name ? `:${name}` : segment;
        })
        .join('/')
        .replace(/\/+$/, '');
    const withSplat = splat ? `${pattern}/*` : pattern;
    return withSplat.startsWith('/') ? withSplat : `/${withSplat}`;
}
